import {useFetch} from "../useFetch";
import {GroupGeofence} from "../../types/api/guide/groupGeofence.types";
import {groupGeofenceService} from "../../services/guide/groupGeofence-service";

export const useFetchGetGroupGeofenceById = (id?: string) => {

    const { isLoading, error, data } =
        useFetch<GroupGeofence>(
            groupGeofenceService.getById,
            [id],
            { enabled: Boolean(id) });

    return { data: data as GroupGeofence, isLoading, error };
}